import React from 'react';


const Map = () => {
  return (
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50378.108423464415!2d-78.46669027479238!3d-0.2134874365643823!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91d59126c0227919%3A0x7661e361a4efe48d!2sScala%20Shopping%20Mall!5e0!3m2!1ses!2sec!4v1715947708157!5m2!1ses!2sec"
      width="100%"
      height="450"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  );
};


export default Map;
